var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLexoMeShumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 19.2,
    viewBox: "0 0 40 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "read_more_FILL1_wght400_GRAD0_opsz48",
    d: "M18.85,25.5H5.5a1.5,1.5,0,1,1,0-3H18.85l-5.5-5.55a1.639,1.639,0,0,1-.425-1.05,1.354,1.354,0,0,1,.425-1.05,1.45,1.45,0,0,1,2.1,0l8.1,8.1a1.45,1.45,0,0,1,0,2.1l-8.1,8.1a1.45,1.45,0,0,1-2.1,0,1.354,1.354,0,0,1-.425-1.05,1.639,1.639,0,0,1,.425-1.05Zm9.65-8a1.5,1.5,0,1,1,0-3h14a1.5,1.5,0,1,1,0,3Zm0,16a1.5,1.5,0,1,1,0-3h14a1.5,1.5,0,1,1,0,3Zm6-8a1.5,1.5,0,1,1,0-3h8a1.5,1.5,0,1,1,0,3Z",
    transform: "translate(-4 -14.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexoMeShumIcon);
export default __webpack_public_path__ + "static/media/lexo_me_shum_icon.a4d7ce4415faf39d811849ae95c398e4.svg";
export { ForwardRef as ReactComponent };